import { render } from "./ClientsTable.vue?vue&type=template&id=0da0bd84&scoped=true"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"

import "./ClientsTable.vue?vue&type=style&index=0&id=0da0bd84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da0bd84"]])

export default __exports__